import React from 'react';
import { Box, Icon, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

// generate a chakra component with a tooltip wrapped icon and onClick handler
const TooltipIcon = ({ as, label, onClick, delay = 200, ...props }) => (
  <Tooltip aria-label={label} label={label} openDelay={delay} placement="top">
    <Box as="span" {...props}>
      <Icon as={as} {...props} onClick={onClick} />
    </Box>
  </Tooltip>
);

TooltipIcon.propTypes = {
  as: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  delay: PropTypes.number
};

export default TooltipIcon;
